import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataTable"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M9 13.5H6V15H9V13.5zM13.5 13.5H10.5V15H13.5V13.5zM9 10.5H6V12H9V10.5zM13.5 16.5H10.5V18H13.5V16.5zM18 10.5H15V12H18V10.5zM18 16.5H15V18H18V16.5z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M20.25 2.25H3.75C3.35233 2.2505 2.97108 2.40869 2.68989 2.68989C2.40869 2.97108 2.2505 3.35233 2.25 3.75V20.25C2.2505 20.6477 2.40869 21.0289 2.68989 21.3101C2.97108 21.5913 3.35233 21.7495 3.75 21.75H20.25C20.6477 21.7495 21.0289 21.5913 21.3101 21.3101C21.5913 21.0289 21.7495 20.6477 21.75 20.25V3.75C21.7495 3.35233 21.5913 2.97108 21.3101 2.68989C21.0289 2.40869 20.6477 2.2505 20.25 2.25ZM20.25 3.75V6.75H3.75V3.75H20.25ZM3.75 20.25V8.25H20.25V20.25H3.75Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataTable.vue"]]);
